// 獲取當前網頁的 URL

var url = window.location.href;

// 判斷 URL 的 get 參數是否為 "pass=sealvax"
if (url.indexOf("pass=sealvax") > -1) {
  // 符合條件，可以進入網頁
  console.log("進入網頁");
} else {
  // 不符合條件，跳轉到 "/blogs/recipes"
  window.location.href = "/blogs/recipes";
}
